export const notiTypes = {
  riskProfile: "riskProfile",
};
